import { render, staticRenderFns } from "./SpecialistHistoryPanel.vue?vue&type=template&id=1f661be8&scoped=true"
import script from "./SpecialistHistoryPanel.vue?vue&type=script&lang=js"
export * from "./SpecialistHistoryPanel.vue?vue&type=script&lang=js"
import style0 from "./SpecialistHistoryPanel.vue?vue&type=style&index=0&id=1f661be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f661be8",
  null
  
)

export default component.exports